import React, { useMemo } from "react";
import CommonTable from "../../../../global/table";
import { formatDateTime, formatDateTimeFromNow } from "../../../../../utils/functions";
import NoRecordFound from "../../../../global/noRecordFound";

const EnhancedPaymentHistoryList = ({
    paymentHistory,
    sort,
    setSort,
    isLoading,
    handleViewDetails
}) => {
    const columns = [
        {
            title: "Customer Name",
            dataIndex: "User.name",
            key: "User.name",
            render: (text, record) => record.User?.name || "N/A",
            isAvatar: true,
            sortType: "User.name"
        },
        {
            title: "Customer Email",
            dataIndex: "userEmail",
            key: "userEmail",
            sortType: "userEmail"
        },
        {
            title: "Payment At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => (
                <div>
                    {formatDateTime(text)}
                    <br />
                    <small className="text-muted">
                        {formatDateTimeFromNow(text)}
                    </small>
                </div>
            ),
            sortType: "createdAt"
        },
        {
            title: "Payment Gateway",
            dataIndex: "paymentGateway",
            key: "paymentGateway",
            sortType: "paymentGateway"
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (text) => `$${text}`,
            sortType: "amount"
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            sortType: "description"
        }
    ];

    const data = useMemo(() => {
        if (!paymentHistory || !paymentHistory.payments) return [];
        return paymentHistory.payments.map((item, idx) => ({
            ...item,
            key: item._id || idx,
            id: item._id || idx,
        }));
    }, [paymentHistory]);


    return (
        <CommonTable
            columns={columns}
            data={data}
            sort={sort}
            setSort={setSort}
            onRowClick={(record) => handleViewDetails && handleViewDetails(record)}
        />
    );
};

export default EnhancedPaymentHistoryList;
